

export default {
name: 'newsDetail',
components: {

},
data () {
return {
newsInfo: {},
}
},
methods: {
getNewsDetail () {
this.$request.post('/news/getNewsById',{
id: this.$route.query.id
}).then(data => {
if(data.code == 0){
this.newsInfo = {...data.obj,clicked: false}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
},
created () {
this.getNewsDetail()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/newsDetail/script.js